import { z } from 'zod';

export const SuperAdminRentChargesPageFilterFormSchema = z.object({
    startDate: z.date().nullable(),
    endDate: z.date().nullable(),
    tenantId: z.string().nullable(),
    documentNumber: z.string().nullable(),
    hotelId: z.string().nullable(),
    apartmentId: z.string().nullable(),
});

export type SuperAdminRentChargesPageFilterFormData = z.infer<typeof SuperAdminRentChargesPageFilterFormSchema>;
